module.exports = __webpack_public_path__ + "img/img_logo.9c51760a.png";